import { render, staticRenderFns } from "./RichTextInput.vue?vue&type=template&id=bb416706&scoped=true&"
import script from "./RichTextInput.vue?vue&type=script&lang=js&"
export * from "./RichTextInput.vue?vue&type=script&lang=js&"
import style0 from "./RichTextInput.vue?vue&type=style&index=0&id=bb416706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb416706",
  null
  
)

export default component.exports